module.exports = __webpack_public_path__ + "static/media/qodo.c5a3129f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/qodo.svg
// module id = 1787
// module chunks = 0